/**
@deprecated Remove after BE rethinks their choices
* */
export default (date: string) => (/z/i.test(date) ? date : `${date}Z`);
